import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {cartItemInterface} from "../../shoppingCart/cartItemInterface";
import LookDropdown from "../ui/lookDropdown";
import {changeCartFeature} from "../../../actions/actionFunctions";
import {getCartItemShippingCost} from "../lookNavigation/lookFunctions2";


const LookListMainFeatureShipping = (props) => {

  const {cartItem, deliveryList, fabricatorSettings, changeCartFeature, intl} = props;

  const shippingCost = getCartItemShippingCost(cartItem);
  if (!shippingCost) {
    return null
  }

  const existingFeature = deliveryList.find(shippingOption => {
    if (!cartItem.cartFeature || !cartItem.cartFeature.dbFeature) {
      return false
    }
    return shippingOption.dbFeatureId === cartItem.cartFeature.dbFeature.id
  });

  if (!existingFeature || !existingFeature.options || !existingFeature.options.length) { // no options available
    return <span>{cartItem.shippingName}: {cartItem.shippingCost}</span>
  }

  const selectItemClick = (selectItem) => {
    const delivery = existingFeature.options.find(item => item.cost === selectItem.value && item.title === selectItem.name);
    changeCartFeature(Object.assign({}, cartItem, {
      shippingCost: selectItem.value,
      shippingName: selectItem.name,
      shippingTime: delivery.delivery,
      shippingCode: delivery.code,
    }));
  }

  const selectItems = existingFeature.options.map(option => {
    const cost = Math.trunc(option.cost * 100) / 100;
    return {
      text: "",
      label: cost
        ? fabricatorSettings.currencySign + cost
        : intl.formatMessage({id: "grohe.cart.option.free"}),
      value: cost,
      name: option.title,
      preText: option.title + (option.delivery !== option.title ? " (" + option.delivery + ")" : "") + ":",
    }
  });

  const selectedItem = selectItems.find(item => item.value === shippingCost) || selectItems[0];

  return (
    <LookDropdown className="look-select--auto"
                  selectLabel={selectedItem.label}
                  selectItems={selectItems}
                  selectedItem={selectedItem}
                  selectItemClick={selectItemClick}/>
  )
};

LookListMainFeatureShipping.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface).isRequired,
}

const mapStateToProps = (store) => {
  const {deliveryList} = store.cartState;
  const {settings} = store.fabricatorState;

  return {
    deliveryList,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {
  changeCartFeature
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookListMainFeatureShipping)
)
